import styled from 'styled-components';

const Title3 = styled.h3`
  color: #2e2d29;
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  margin: 0px;
`;

export default Title3;
